import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { clearLayoutState } from "../layout/layoutSlice";
import { clearModalState } from "../modal/modalSlice";
import { clearUserState } from "../user/userSlice";
import { clearUyelerAraclarSlice } from "../uyelerAraclar/uyelerAraclarSlice";
import { setRegisterResultModalData, showRegisterModal } from "../register/registerSlice";
import { getAdminOrUserClaims } from "../companyProfile/companyAuthorizationSlice";
import axiosInstance from "../../axios/axiosInstance";


const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
const initialState = {
    user: null,
    isLoadingLogin: false,
    isError: false,
    message:null,
    token: JSON.parse(storage.getItem("accessToken")) || null,
    // adminUserName: "",
    // adminMail: "",
    forgotData: {
        email:"",
        code:"",
        password1:"",
        password2:""
    },

    forgotPasswordVerificationStatus: false,

    forgotPasswordVerificationCodeTimer: 180,

    isLoadingSendMail: false,
    isLErrorSendMail: false,
    isLoadingSendVerification: false,
    isErrorSendVerification: false,
    isSuccessVerification: false,
    isLoadingNewPassword: false,
    isErrorNewPassword: false,
}

export const login = createAsyncThunk("auth/login", async({loginData, isFromRegister, isRemember}, thunkApi)=> {
    try {
        const {data} = await axios.post(`${process.env.REACT_APP_API_URI}/Auth/LoginWebUserWithPassword`, loginData)
        let t = {};
        t = JSON.parse(window.atob(data.data.accessToken.split('.')[1]));

        const role = t["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        const RoleId = t["http://schemas.xmlsoap.org/ws/2009/09/identity/claims/actor"];
        const companyId = t["http://schemas.microsoft.com/ws/2008/06/identity/claims/serialnumber"]
        const userId =  t["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]
        
        const storage = isRemember ? localStorage : sessionStorage;

        if( data.data.accessToken && data.data.accessTokenExpiration && data.data.refreshToken && data.data.refreshTokenExpires){
            storage.setItem("accessToken", JSON.stringify(data.data.accessToken))
            storage.setItem("accessTokenExpiration", JSON.stringify(data.data.accessTokenExpiration))
            storage.setItem("refreshToken", JSON.stringify(data.data.refreshToken))
            storage.setItem("refreshTokenExpires", JSON.stringify(data.data.refreshTokenExpires))
            storage.setItem("role", JSON.stringify(role))
            storage.setItem("roleId", JSON.stringify(RoleId))
            storage.setItem("companyId", JSON.stringify(companyId))
            storage.setItem("userId", JSON.stringify(userId))
            storage.setItem("isRemember", JSON.stringify(isRemember))
            if(isFromRegister){
                window.location.href = "/profilim/firma-bilgileri"
            }
        }
        thunkApi.dispatch(getAdminOrUserClaims())
        thunkApi.dispatch(getRLD(isRemember))
        
        return {RoleId, token:data.data.accessToken, error:data?.error?.errors?.$values?.[0]}
         
    } catch (error) {
        thunkApi.dispatch(setErrorMessage(error.response.data.error.errors.$values[0]))
        return thunkApi.rejectWithValue(error.response.data.error)
    }
})




//! kodu kontrol etme apisi
export const getRLD = createAsyncThunk("auth/getRLD", async(isRemember, thunkApi) => {
    try{
        
        const storage = isRemember ? localStorage : sessionStorage;

        const {data} = await axiosInstance.post(`${process.env.REACT_APP_API_URI}/user/getRld`)
        
        if(data.rLd){
            storage.setItem("rld", JSON.stringify(data.rLd))
        }

        return data.data
      }catch(error){
        
        thunkApi.dispatch(setErrorMessage(error.response.data.ErrorDto.Errors[0]))
        return thunkApi.rejectWithValue(error)
      }
})




export const logoutUser = createAsyncThunk("auth/logoutUser", async (_, thunkAPI) => {

    localStorage.clear();
    sessionStorage.clear();

    thunkAPI.dispatch(clearLayoutState())
    thunkAPI.dispatch(clearModalState())
    thunkAPI.dispatch(clearUserState())
    thunkAPI.dispatch(clearUserState())
    thunkAPI.dispatch(clearUyelerAraclarSlice())
    window.location ="/giris-yap"
})

//! kod alma apisi
export const sendMailAdresForVerificationForgot = createAsyncThunk("auth/sendMailAdresForVerification", async(email, thunkApi)=> {
    try {
        const token = thunkApi.getState().auth.token
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const {data} = await axios.post(`${process.env.REACT_APP_API_URI}/Auth/ForgotMailVerificationRegister`, email, config)
        
        if(data.data.isVerificationCodeSended){
            thunkApi.dispatch(showRegisterModal("forgotVerificationCode"))
            thunkApi.dispatch(setForgotPasswordVerificationStatus(true))
            thunkApi.dispatch(setForgotPasswordVerificationCodeTimer(180))
            thunkApi.dispatch(setErrorMessage(null))
        }
        return data
    } catch (error) {
        
        thunkApi.dispatch(setErrorMessage(error.response.data.ErrorDto.Errors[0]))
        return thunkApi.rejectWithValue(error)
    }
})

//! kodu kontrol etme apisi
export const forgotVerificationCheck = createAsyncThunk("auth/forgotVerificationCheck", async(body, thunkApi) => {
    try{
        
        const {data} = await axios.post(`${process.env.REACT_APP_API_URI}/Auth/ForgotCodeVerificationPassword`, body)
        if(data.data.isValidCode){
            thunkApi.dispatch(showRegisterModal(null))
            thunkApi.dispatch(setIsSuccessVerification(true))
            thunkApi.dispatch(setErrorMessage(null))
        }
        return data.data
      }catch(error){
        
        thunkApi.dispatch(setErrorMessage(error.response.data.ErrorDto.Errors[0]))
        return thunkApi.rejectWithValue(error)
      }
})

//! şifremi unuttum şifre değiştirme apisi
export const sendNewPassword = createAsyncThunk("auth/sendNewPassword", async(body, thunkApi) => {
    try{
        
        const {data} = await axios.post(`${process.env.REACT_APP_API_URI}/Auth/ForgotPassword`, body)
        if(data.statusCode === 200){
            thunkApi.dispatch(showRegisterModal("forgotResult"))
            thunkApi.dispatch(setRegisterResultModalData({msg: "Şifreniz başarılı bir şekilde değiştirildi.", resultType: "success", routePath: "/giris-yap"}))
            thunkApi.dispatch(setForgotData({
                email:"",
                code:"",
                password1:"",
                password2:""
            }))
        }
        return data.data
    }catch(error){
        thunkApi.dispatch(setErrorMessage(error.response.data.error.errors.$values[0]))
        return thunkApi.rejectWithValue(error)
    }
})



const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setUserRole: (state, action) => {
            state.userRole = action.payload
        },

        setForgotData: (state, action) => {
            state.forgotData = {...state.forgotData, ...action.payload}
        },

        setIsSuccessVerification: (state, action) => {
            state.isSuccessVerification = action.payload
        },

        setErrorMessage: (state, action) => {
            state.message = action.payload
        },

        setForgotPasswordVerificationStatus: (state, action) => {
            state.forgotPasswordVerificationStatus = action.payload
        },

        setForgotPasswordVerificationCodeTimer: (state, action) => {
            state.forgotPasswordVerificationCodeTimer = action.payload
        }

    },
    extraReducers:(builder)=> {
        builder
        
        // login
        .addCase(login.pending, (state)=> {
            state.isLoadingLogin = true

        })
        .addCase(login.fulfilled, (state, action)=> {
            state.isLoadingLogin = false
            state.userRole = action.payload.role
            state.token = action.payload.token
            state.message = action.payload.error
            state.user = true
        })

        .addCase(login.rejected, (state, action)=> {
            state.isLoadingLogin = false
            state.isError = true
        })

        .addCase(logoutUser.fulfilled, (state, action)=> {
           return initialState
        })

        //! kod için mail gödnerme
        .addCase(sendMailAdresForVerificationForgot.pending, (state)=> {
            state.isLoadingSendMail = true
        })
        .addCase(sendMailAdresForVerificationForgot.fulfilled, (state, action)=> {
            state.isLoadingSendMail = false
        })

        .addCase(sendMailAdresForVerificationForgot.rejected, (state, action)=> {
            state.isLoadingSendMail = false
            state.isLErrorSendMail = true
        })

        //! kodu onaylama
        .addCase(forgotVerificationCheck.pending, (state)=> {
            state.isLoadingSendVerification = true
        })
        .addCase(forgotVerificationCheck.fulfilled, (state, action)=> {
            state.isLoadingSendVerification = false
        })

        .addCase(forgotVerificationCheck.rejected, (state, action)=> {
            state.isLoadingSendVerification = false
            state.isErrorSendVerification = true
        })

        //! şifremi unuttum şifre değiştirme apisi
        .addCase(sendNewPassword.pending, (state)=> {
            state.isLoadingNewPassword = true
        })
        .addCase(sendNewPassword.fulfilled, (state, action)=> {
            state.isLoadingNewPassword = false
        })

        .addCase(sendNewPassword.rejected, (state, action)=> {
            state.isLoadingNewPassword = false
            state.isErrorNewPassword = true
        })

        
    }
})


export const {setErrorMessage, setUserRole, setAdminUserName, setAdminMail, setForgotData, setIsSuccessVerification, setForgotPasswordVerificationCodeTimer, setForgotPasswordVerificationStatus} = authSlice.actions
export default authSlice.reducer